/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/**
 * NexleaderLicenseDiscountsComponent
 *
 * VIEW
 *
 * Lists LicenseDiscounts and lets super admins create and delete them. Like the team report discounts,
 *  there is no edit; delete the old code and create a new one.
 */

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { catchError, of, take, tap } from 'rxjs';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { SuccessService } from '../../../../services/success.service';
import { LicenseDiscountService } from '../../resources/license-discount.service';
import { NexleaderNewLicenseDiscountModalComponent } from '../../components/modals/new-license-discount-modal/new-license-discount-modal.component';
import { NexleaderActionAnchorDirective } from '../../../../directives/action-anchor.directive';

@Component({
  selector: 'app-nexleader-license-discounts',
  standalone: true,
  imports: [NexleaderActionAnchorDirective, CommonModule],
  templateUrl: './license-discounts.component.html',
})
export class NexleaderLicenseDiscountsComponent implements OnInit {
  licenseDiscounts: any[] = [];

  constructor(
    private modalService: BsModalService,
    private errorHandlerService: ErrorHandlerService,
    private successService: SuccessService,
    private licenseDiscountService: LicenseDiscountService
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.licenseDiscountService
      .getAll()
      .pipe(
        tap((licenseDiscounts) => {
          this.licenseDiscounts = licenseDiscounts;
        }),
        catchError((error) => {
          this.errorHandlerService.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }

  openCreateLicenseDiscount(): void {
    const modalRef = this.modalService.show(
      NexleaderNewLicenseDiscountModalComponent
    );
    modalRef.onHidden?.pipe(take(1)).subscribe(() => {
      this.load();
    });
  }

  remove(licenseDiscount: any): void {
    if (!confirm(`Are you sure you want to delete discount code "${licenseDiscount.name}"?`)) {
      return;
    }

    this.licenseDiscountService
      .remove(licenseDiscount._id)
      .pipe(
        tap(() => {
          this.successService.handle({
            message: 'Successfully deleted license discount code.',
          });
          this.load();
        }),
        catchError((error) => {
          this.errorHandlerService.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }
}
